import httpRequest from '@/utils/request';

const quotationCategoryUrl = '/QuotationCategory';
const updateCategoryUrl = (categoryId: string) => {
  return `/QuotationCategory/${categoryId}`;
};

export const getQuotationCategory = (
  params: IQuotation.IRequest.IGetCategory = {},
): Promise<IQuotation.IResponse.ICategoryData> => {
  return httpRequest.get(quotationCategoryUrl, {
    params,
  });
};
export const createOrUpdateCategory = (
  params: IQuotation.IRequest.IUpdateCategory,
): Promise<IResponseData.IBaseData> => {
  const {id, ...data} = params;
  return httpRequest.post(updateCategoryUrl(id), data);
};
export const delCategory = (categoryId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(updateCategoryUrl(categoryId));
};
